/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EdrOrgRequester { 
    /**
     * Requester email address
     */
    email?: string;
    /**
     * Requester first name
     */
    first_name?: string;
    /**
     * Requester last name
     */
    last_name?: string;
}

